export default {
  title: "",
  content: [
    "HOW to know you're ready to adopt",
    "HOW you can obtain required training hours without having to go in-person to a class",
  ],
};
